import {BaseModel} from '../base/BaseModel';
import {WeatherModel} from './WeatherModel';

import {UnitConverter} from '../../utils/UnitConverter';

/**
 * @class Weather2Model
 * @extends WeatherModel
 *
 * @property {object} attributes
 */
export class Weather2Model extends WeatherModel {

    get idAttribute () {

        return 'startDatetime';
    }

    get defaults () {

        return {
            uuidForeign: undefined,
            date: undefined,
            startDatetime: undefined,
            airTempCMin: undefined,
            airTempCMax: undefined,
            airTempCAvg: undefined,
            precipitationBestMm: undefined,
            sunshineDurationH: undefined,
            windSpeedMSAvg: undefined,
            windDirectionDeg: undefined,
            weatherDescriptorImage: undefined,
            deltaTCAvg: undefined,

            // Used in multiple views
            airTempMinLocal: undefined,
            airTempMaxLocal: undefined,
            airTempAvgLocal: undefined,
            windSpeedLocal: undefined,
            precipitationLocal: undefined,
            deltaTcAvgLocal: undefined
        };
    }

    parse (modelToParse) {

        if (_.isString(modelToParse.date)) {
            modelToParse.date = BaseModel.parseDate(modelToParse.date);
        }

        if (_.isString(modelToParse.startDatetime)) {
            modelToParse.startDatetime = BaseModel.parseDate(modelToParse.startDatetime);
        }

        if (!_.isUndefined(modelToParse.windSpeedMSAvg) && !_.isNull(modelToParse.windSpeedMSAvg)) {
            modelToParse.windSpeedLocal = UnitConverter.siToLocal(modelToParse.windSpeedMSAvg, __('_WIND_SPEED_UNIT'));
        }

        if (!_.isUndefined(modelToParse.airTempCMin) && !_.isNull(modelToParse.airTempCMin)) {
            modelToParse.airTempMinLocal = Weather2Model.temperatureUnitConvertor(modelToParse.airTempCMin, __('_TEMP_UNIT'));
        }

        if (!_.isUndefined(modelToParse.airTempCMax) && !_.isNull(modelToParse.airTempCMax)) {
            modelToParse.airTempMaxLocal = Weather2Model.temperatureUnitConvertor(modelToParse.airTempCMax, __('_TEMP_UNIT'));
        }

        if (!_.isUndefined(modelToParse.airTempCAvg) && !_.isNull(modelToParse.airTempCAvg)) {
            modelToParse.airTempAvgLocal = Weather2Model.temperatureUnitConvertor(modelToParse.airTempCAvg, __('_TEMP_UNIT'));
        }

        if (!_.isUndefined(modelToParse.deltaTCAvg) && !_.isNull(modelToParse.deltaTCAvg)) {
            modelToParse.deltaTcAvgLocal = Weather2Model.temperatureUnitConvertor(modelToParse.deltaTCAvg, __('_TEMP_UNIT'));
        }

        if (!_.isUndefined(modelToParse.precipitationBestMm) && !_.isNull(modelToParse.precipitationBestMm)) {
            modelToParse.precipitationLocal = UnitConverter.siToLocal(modelToParse.precipitationBestMm, __('_PRECIPITATION_UNIT'));
        }
        
        if (!_.isUndefined(modelToParse.precipitationMmAcc) && !_.isNull(modelToParse.precipitationMmAcc)) {
            modelToParse.precipitationAccLocal = UnitConverter.siToLocal(modelToParse.precipitationMmAcc, __('_PRECIPITATION_UNIT'));
        }

        if (modelToParse.windDirectionDeg) {
            modelToParse.windDirectionDeg = modelToParse.windDirectionDeg + 180;
        }

        return modelToParse;
    }

    static temperatureUnitConvertor (valueInC, temperatureUnit) {

        switch (temperatureUnit) {

            case 'F': return ((valueInC * 1.8) + 32);
            case 'C':
            default :
                return valueInC;
            }
        }
}


// WEBPACK FOOTER //
// ./shared/model/weather/Weather2Model.js